<template lang="pug">
  div(:class="{'content-card': $route.query.context !== 'choice', 'content-card-choice': $route.query.context === 'choice' }")
    v-layout.image-marque.align-center.pt-4.pb-4.pr-4(
      v-if="config"
      :class="{ 'choice-load': $route.query.context === 'choice' }"
    )
      v-layout.flex-row
        v-layout.align-center
          img.ml-5(width="250px" src="@/assets/logo.png")
      v-btn.hidden.right(
        color="#e75239"
        @click="$router.push($route.query.context === 'choice' ? '/choice?context=choice' + chosen : { name: 'maps_list' } )"
        depressed dark
      ) ENREGISTRER
      v-btn.grey--text.right(
        color="#eee"
        @click="$router.push($route.query.context === 'choice' ? '/choice?context=choice' + chosen : { name: 'maps_list' } )"
        depressed dark
      ) RETOUR
    v-layout.justify-space-around.elevation-2(
      v-rc-loader="loading"
      v-if="config"
      :class="{ 'choice-load': $route.query.context === 'choice' }"
    )
      v-flex.grey.lighten-5.config-editor
        v-tabs.edit-tabs(
          v-model="editTypeTab"
          :slider-color="$route.query.context === 'choice' ? '#e75239' : 'primary'"
          dark color="grey lighten-3"
        )
          v-tab(:class="!isChoice ? 'main-text' : 'choice-text'") Fond de carte
          v-tab(data-test="layerTab" :class="!isChoice ? 'main-text' : 'choice-text'") Contenus
          v-tab(data-test="layerTab" :class="!isChoice ? 'main-text' : 'choice-text'") Partenaires
          v-tab(:class="!isChoice ? 'main-text' : 'choice-text'") Options d'affichage
          v-tab(:class="!isChoice ? 'main-text' : 'choice-text'") Légende
          v-tab(:class="!isChoice ? 'main-text' : 'choice-text'") Zones
          v-tab(:class="!isChoice ? 'main-text' : 'choice-text'") Comportements
          v-tab.widget(:class="!isChoice ? 'main-text' : 'choice-text'") Widget
          div.right-boutton
            v-btn.grey--text.right(
              color="#eee"
              @click="$router.push($route.query.context === 'choice' ? '/choice?context=choice' + chosen : { name: 'maps_list' } )"
              depressed dark
            ) RETOUR
            v-btn.hidden.right(
              color="#e75239"
              @click="$router.push($route.query.context === 'choice' ? '/choice?context=choice' + chosen : { name: 'maps_list' } )"
              depressed dark
            ) ENREGISTRER
        v-snackbar(v-model="copiedSnackbar" bottom left :timeout="2000" color="primary")
          |Sauvegarde réussie
        v-layout.flex-row.align-start.fullscreen
          v-tabs-items.screen-options(v-model="editTypeTab")
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-background-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="styleEdit"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-map-layers-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="layerEdit"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-partners-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="partners"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-screen-options-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="screenOptions"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-legend-edit.pt-3.config-editor-content(
                :config="config"
                @changed="params => reload(params, true)"
                ref="legend"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-geojson-edit.pt-3.config-editor-content(
                :config="config"
                @changed="params => reload(params, true)"
                ref="geojson"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-comportements-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="comportements"
              )
            v-tab-item.px-2(transition="fade" reverse-transition="fade")
              rc-widget-edit.pt-3.config-editor-content(
                :config="config"
                @changed="reload"
                ref="widget"
              )
          v-flex.screen-map
            #edit-preview-map
              .zoom-level zoom = {{ zoom }}
</template>

<script>
import mixin from '@/mixins/Rc.mixin.vue';
import RcBackgroundEdit from '@/components/mapEdit/RcBackgroundEdit.vue';
import RcMapLayersEdit from '@/components/mapEdit/RcMapLayersEdit.vue';
import RcPartnersEdit from '@/components/mapEdit/RcPartnersEdit.vue';
import RcScreenOptionsEdit from '@/components/mapEdit/RcScreenOptionsEdit.vue';
import RcComportementsEdit from '@/components/mapEdit/RcComportementsEdit.vue';
import RcWidgetEdit from '@/components/mapEdit/RcWidgetEdit.vue';
import RcGeojsonEdit from '@/components/mapEdit/RcGeojsonEdit.vue';
import RcLegendEdit from '@/components/mapEdit/RcLegendEdit.vue';
import { debounce } from 'debounce';

export default {
  mixins: [mixin],
  components: {
    RcMapLayersEdit,
    RcBackgroundEdit,
    RcPartnersEdit,
    RcScreenOptionsEdit,
    RcComportementsEdit,
    RcWidgetEdit,
    RcGeojsonEdit,
    RcLegendEdit,
  },
  data() {
    return {
      mapId: this.$route.params.id,
      editTypeTab: 0,
      map: null,
      tmap: null,
      loading: true,
      savingPreview: false,
      zoom: null,
      timer: 0,
      copiedSnackbar: false,
      edited_layer: null,
      timer_layer: null,
      // default_layer: null,
    };
  },
  mounted() {
    this.$store.dispatch('config/getById', this.mapId).then(() => {
      if (this.config.position) {
        this.$nextTick(async () => {
          const lat = this.config.position.latitude;
          const lng = this.config.position.longitude;
          const { zoom } = this.config.position;
          this.zoom = Math.floor(zoom);

          const container = document.querySelector('#edit-preview-map');
          const conf = JSON.parse(JSON.stringify(this.config));
          conf.map = { dragging: true, scrollWheelZoom: 2 };
          // eslint-disable-next-line no-undef
          const tm = touristicmaps(container, 'raccourci', conf, conf);
          this.map = tm.map;
          this.tmap = await tm.tm;
          this.map.setView([lat, lng], zoom);
          this.map.on('move', debounce(this.savePosition, 2000));
          this.map.on('move', () => { this.savingPreview = true; });
          // eslint-disable-next-line no-underscore-dangle
          this.map.on('zoom', (val) => { this.zoom = Math.floor(val.target._zoom); });
          // eslint-disable-next-line no-unused-vars
          // const esriLink = document.querySelectorAll("a[href='https://www.esri.com']");
          // eslint-disable-next-line no-unused-vars
          // const leafletLink = document.querySelectorAll("a[href='http://leafletjs.com']");
          this.loading = false;

          // eslint-disable-next-line prefer-destructuring
          const theme = conf.theme;
          this.timer_layer = setInterval(() => {
            if ( // eslint-disable-next-line no-trailing-spaces, operator-linebreak
              (theme.terrain === undefined || !theme.terrain) &&
              (theme.satellite === undefined || !theme.satellite)
            ) {
              this.edited_layer = 'plan';
            } else if (theme.terrain) {
              this.edited_layer = 'terrain';
            } else if (theme.satellite) {
              this.edited_layer = 'satellite';
            }
          }, 1500);
        });
      }
      this.loading = false;
    });
  },
  computed: {
    config() {
      return this.$store.state.config.editing;
    },
    chosen() {
      if (this.$route.query.chosen) return `&chosen=${this.$route.query.chosen}`;
      return '';
    },
    isChoice() {
      return this.$route.query.context === 'choice';
    },
  },
  methods: {
    async reload(params, fullReload) {
      // eslint-disable-next-line no-shadow
      debounce(async (params) => {
        this.savingPreview = true;
        const conf = JSON.parse(JSON.stringify(params));
        conf.map = { dragging: true, scrollWheelZoom: true };
        const conf2 = conf;
        // eslint-disable-next-line default-case
        switch (this.edited_layer) {
          case 'plan':
            conf.theme.terrain = false;
            conf.theme.satellite = false;
            break;
          case 'terrain':
            conf.theme.terrain = true;
            conf.theme.satellite = false;
            break;
          case 'satellite':
            conf.theme.terrain = false;
            conf.theme.satellite = true;
            break;
        }
        // eslint-disable-next-line prefer-destructuring
        const theme = conf.theme;
        clearInterval(this.timer_layer);
        this.timer_layer = setInterval(() => {
          if (// eslint-disable-next-line no-trailing-spaces, operator-linebreak
            (theme.terrain === undefined || !theme.terrain) &&
            (theme.satellite === undefined || !theme.satellite)
          ) {
            this.edited_layer = 'plan';
          } else if (theme.terrain) {
            this.edited_layer = 'terrain';
          } else if (theme.satellite) {
            this.edited_layer = 'satellite';
          }
        }, 1500);
        // Only to regen map with edited layer (if not fullReload)
        // eslint-disable-next-line no-undef
        const tm = await touristicmaps.reload(conf, fullReload);
        // eslint-disable-next-line no-underscore-dangle
        this.map = tm.map || tm._map;
        this.tmap = await tm.tm;
        // eslint-disable-next-line no-undef
        await touristicmaps.reload(conf2); // Only to save conf with default layer
        // Twice call can be make in only one if function 'touristicmaps.reload()'
        // is modified in 'http_tiles' project
        await this.$store.dispatch('config/edit', { id: this.config.id, params });
        // eslint-disable-next-line no-restricted-globals
        parent.postMessage(this.config.id, '*');
        this.$refs.styleEdit.loading = false;
        this.$refs.layerEdit.loading = false;
        this.savePopup();
      }, 50)(params);
    },
    async generatePreview() {
      const snap = await this.tmap.scene.screenshot();
      const img = new Image();
      const maxWidth = '200px';
      const maxHeight = '200px';
      const context = this;
      img.src = window.URL.createObjectURL(snap.blob);
      img.onload = () => {
        const canvas = document.createElement('canvas');
        // eslint-disable-next-line prefer-destructuring
        let width = img.width;
        // eslint-disable-next-line prefer-destructuring
        let height = img.height;
        if (width > height) {
          if (width > maxWidth) {
            // height *= max_width / width;
            height = Math.round(height *= maxWidth / width);
            width = maxWidth;
          }
        } else if (height > maxHeight) {
          // width *= max_height / height;
          width = Math.round(width *= maxHeight / height);
          height = maxHeight;
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((newBlob) => {
          context.$store.dispatch(
            'config/createPreview',
            { id: context.config.id, params: newBlob },
          );
        }, 'image/jpeg', 0.2); // send it to canvas
        context.savingPreview = false;
      };
    },
    async savePosition() {
      this.savingPreview = true;
      const center = this.map.getCenter();
      this.config.position.latitude = center.lat;
      this.config.position.longitude = center.lng;
      this.config.position.zoom = this.map.getZoom();
      await this.$store.dispatch(
        'config/edit',
        {
          id: this.mapId,
          params: this.filterConfig(this.config),
          throwError: false,
        },
      );
    },
    previewIsDone(callback) {
      if (this.savingPreview) {
        window.setTimeout(() => { this.previewIsDone(callback); }, 100);
      } else {
        callback();
      }
    },
    savePopup() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.copiedSnackbar = true; }, 1500);
    },
    saveActiveLayer(theme) {
      if (theme.satellite === undefined || theme.terrain === undefined) {
        this.edited_layer = 'plan';
      } else if (theme.terrain) {
        this.edited_layer = 'terrain';
      } else if (theme.satellite) {
        this.edited_layer = 'satellite';
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // next(false);
    clearTimeout(this.timer_layer);
    this.edited_layer = '';
    this.generatePreview();
    this.previewIsDone(next);
  },
};
</script>

<style lang="scss" scoped>
  #edit-preview-map {
    height: 100%;
    width: 100%;
  }
</style>

<style lang="scss">
  .screen-options {
    height: 100%;
    width: 30%;
    min-width:425px;
    overflow-x: visible !important;
  }
  .choice-load .screen-map{
    height: calc(100vh - 150px);
    width: calc(100vw - 30vw);
  }
  @media (max-width: 1430px) {
    .choice-load .screen-map{
      height: calc(100vh - 150px);
      width: calc(100vw - 425px);
    }
  }

  .screen-map {
    height:  calc(100vh - 270px);
    width: calc(100vw - 30vw - 50px);
    margin-left:30vw;
    position:fixed;
  }
  @media (max-width: 1430px) {
    .screen-map {
      height: calc(100vh - 270px);
      width: calc(100vw - 475px);
      margin-left:425px;
      position:fixed;
    }
  }
  .choice-load .fullscreen {
    height: calc(100vh - 150px);
    width: auto;
    overflow-y: auto;
  }
  .fullscreen {
    height: calc(100vh - 268px);
    width: auto;
    overflow-y: auto;
  }
  .choice-load .widget{
    display: none;
  }
  .zoom-level {
    position: absolute;
    z-index: 500;
    left: 15px;
    top: 15px;
    background-color: #fff;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background-clip: padding-box;
    font-size: 13px;
    padding: 5px 10px;
  }

  .main-text {
    color: #e75239;
    a {
      color: #e75239;
    }
  }
  .choice-text {
    color: #e75239 !important;
  }

  .edit-tabs {
    .v-window {
      background-color: white;
      .v-window-item {
        height: 100%;
        overflow-y: auto;
      }
    }
  }
  .v-window__container--is-active{
    overflow: visible !important;
  }
  .v-tabs__item{
    padding: 8px 20px;
    white-space: nowrap;
    font-size:16px;
  }
  .right{
    background-color: white;
    font-size:16px;
    margin-right: 10px;
    margin-left: 10px;
  }
  .right-boutton{
    width: 80%;
    background-color: white;
  }
  .hidden{
    visibility: hidden;
  }
  .image-marque{
    display: none;
  }
  .choice-load.image-marque{
    display: block;
  }
  .choice-load .right-boutton{
    display: none;
  }
  .esri-truncated-attribution {
    vertical-align: -3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    transition: 0s white-space;
    transition-delay: 1s;
    max-width: 1853px;
  }
  .esri-truncated-attribution:hover {white-space: normal;}
</style>
